import { render, staticRenderFns } from "./tableScheme.vue?vue&type=template&id=3e106704&scoped=true"
import script from "./tableScheme.vue?vue&type=script&lang=js"
export * from "./tableScheme.vue?vue&type=script&lang=js"
import style0 from "./tableScheme.vue?vue&type=style&index=0&id=3e106704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e106704",
  null
  
)

export default component.exports